export function getWindowVariable<T>(windowVariable: string): T {
	return window[windowVariable as keyof typeof window];
}
